export default "__VITE_ASSET__DjsLXPzL__"